var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgK8SStatefulSet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 2h10a1 1 0 0 1 1 1v4h-1V3H3v10h5v1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 11c1.657 0 3-.672 3-1.5S13.657 8 12 8s-3 .672-3 1.5 1.343 1.5 3 1.5m1.94-1.5C13.439 9.075 12.622 9 12 9s-1.439.075-1.94.5c.501.425 1.318.5 1.94.5s1.439-.075 1.94-.5",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 11.5c0 .828 1.343 1.5 3 1.5s3-.672 3-1.5h-1c-.497.422-1.393.5-2 .5s-1.503-.078-2-.5zM12 15c-1.657 0-3-.672-3-1.5h1c.497.422 1.393.5 2 .5s1.503-.078 2-.5h1c0 .828-1.343 1.5-3 1.5M9.875 7.302a2 2 0 1 0-2.573 2.573 4.5 4.5 0 0 0-.255.97 3.001 3.001 0 1 1 3.798-3.798 4.5 4.5 0 0 0-.97.255"
})));
export default SvgK8SStatefulSet;